// extracted by mini-css-extract-plugin
export var card = "_a8-0";
export var failedIcon = "_a8-4";
export var failedIconBadge = "_a8-3";
export var icon = "_a8-1";
export var successIcon = "_a8-2";